import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { Divider } from '@usepepper/ui/atoms/divider';
import { View } from 'react-native';

const ROW_COUNT = 5;
const ROW_HEIGHT = 48;

// Standard (non-competitive) quote columns: item #, name, description,
// pack size, price, per unit, qty, total, remove. Mirror the live table's
// flex ratios.
const COLUMN_FLEX = [9, 19, 11, 11, 11, 11, 8, 15, 5];

/**
 * Placeholder shown over the line-items area while a saved quote's
 * detail query is in flight.
 */
export const QuoteLineItemsTableSkeleton: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.price_quotes.table.loading_a11y',
      )}
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      style={styles.container}
    >
      <View style={styles.header}>
        {COLUMN_FLEX.map((flex, i) => (
          <View key={i} style={[styles.column, { flex }]}>
            <AnimatedSkeletonLoader borderRadius={4} height={10} width={24} />
          </View>
        ))}
      </View>
      <Divider />
      {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
        <View key={rowIndex} style={{ opacity: 1 - rowIndex * 0.15 }}>
          <View style={styles.row}>
            {COLUMN_FLEX.map((flex, colIndex) => (
              <View key={colIndex} style={[styles.column, { flex }]}>
                <AnimatedSkeletonLoader
                  borderRadius={4}
                  height={14}
                  width="80%"
                />
              </View>
            ))}
          </View>
          <Divider />
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  column: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingRight: theme.sk.spacing.spaceMedium,
  },
  container: {
    flex: 1,
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
  header: {
    flexDirection: 'row',
    minHeight: 32,
    paddingBottom: theme.sk.spacing.spaceSmall,
    paddingTop: theme.sk.spacing.spaceMedium,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    minHeight: ROW_HEIGHT,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
}));
